module.exports = __webpack_public_path__ + "media/images/box_sizes/M-50716c628496a557f625b1da89a2778a.jpg";